import BccRwdCopy from 'components/Bcc/BccRwdCopy/BccRwdCopy';

export default BccRwdCopy;
